import { request } from "./http";

export interface Branding {
  name: string | null;
  slug: string | null;
  branding: {
    primary_color?: string;
    accent_color?: string;
    logo_url?: string;
    favicon_url?: string;
    company_name?: string;
  };
  matched_via: "default" | "slug" | "domain";
}

export const branding = {
  /** Resolution order: explicit slug → Host header (default in prod). */
  load: (slug?: string) =>
    request<Branding>(
      slug ? `/api/v1/branding?slug=${encodeURIComponent(slug)}` : "/api/v1/branding",
      { noAuth: true },
    ),
};
